<template>
    <div class="educateWrap">
        <div v-if="teacher" class="ter_item">
            <div class="item_left">
                <div class="ter_name">
                    <div class="ter_uname">{{ teacher.isRecommend ? teacher.userName : teacher.nickname }}</div>
                    <div v-if="teacher.jobTitle" class="ter_jobTitle">{{ teacher.jobTitle }}</div>
                </div>
                <div class="textBlock">
                    <div class="floating_window" v-html="ImgSizeLimit(teacher.profile)" />

                </div>
            </div>
            <div class="item_right">
                <div class="ter_img">
                    <div class="ter_img_bg"></div>
                    <div class="ter_img_bg ter_img_bg1">
                        <img :src="teacher.terImg" alt="" />
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
 
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
    components: {},

    props: ['id'],
    data() {
        return {
            teacher: {}
        }
    },
    async created() {
        this.getTeacherList();

       
    },
     methods: {
        async getTeacherList() {
            const res = await homeClient.getTeacherInfoById({
                courseId: this.id
            });
            if (res.code == 0) {
                this.teacher = res.data || [];
            }
        }
    }
}
</script>

<style lang="less" scoped>
.educateWrap {
    padding: 20px 0;
    margin-bottom: 20px;

    .ter_item {
        width: 95%;
        height: 268px;
        background: url('https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/bg999.png');
        background-size: 100% 100%;
        border-radius: 10px 10px 10px 10px;
        margin: 0 auto;
        // margin-top: 10px;
        display: flex;
        justify-content: space-between;

        .item_left {
            padding: 47px 41px 37px 51px;

            .ter_name {
                display: flex;
                align-items: center;

                .ter_uname {

                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 20px;
                    color: #333333;
                }

                .ter_jobTitle {
                    padding: 1px 14px;
                    border-radius: 15px;
                    border: 1px solid #FF5E51;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #FF5E51;
                    margin-left: 10px;
                }
            }

            .textBlock {

                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                line-height: 24px;
                margin-top: 14px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
            }
        }

        .item_right {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            margin-right: 60px;
            margin-bottom: 32px;

            .ter_img {
                display: flex;
                position: relative;

                .ter_img_bg {
                    position: relative;
                    width: 165px;
                    height: 198px;
                    background: #FF9E77;
                    border-radius: 97px 97px 0px 0px;
                    overflow: hidden;
                    bottom: 0;

                    img {
                        width: 100%;
                        height: fit-content;
                    }
                }

                .ter_img_bg1 {
                    position: absolute;
                    left: 10px;
                }
            }
        }
    }
}
</style>